import { render, staticRenderFns } from "./Vtest.vue?vue&type=template&id=f6c6c524&"
import script from "./Vtest.vue?vue&type=script&lang=js&"
export * from "./Vtest.vue?vue&type=script&lang=js&"
import style0 from "./Vtest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports